import styles from '@components/Loading/Loading.styles';
import theme from '@styles/theme';
type PropsType = {
  color?: string;
};
const Loading = ({
  color = theme.rawColors.darkGrey700
}: PropsType) => {
  const numbers = [...Array(12).keys()];
  return <div sx={styles.loadingContainer} data-cy="Loading">
      <div sx={styles.loading(color)}>
        {numbers.map((_, index) => <div key={index} />)}
      </div>
    </div>;
};
export default Loading;